// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__oY6Uc","name":"Header_name__2nxA_","birthday":"Header_birthday__12iD_","skeleton":"Header_skeleton__xH_tg"};